// extracted by mini-css-extract-plugin
module.exports = {"label":"TenantSelectionForm_label__G5lmy","tenantSelection":"TenantSelectionForm_tenantSelection__1Q_0v"};